import { render } from "./PaginatedCompanyDropdown.vue?vue&type=template&id=afb8dc04&ts=true"
import script from "./PaginatedCompanyDropdown.vue?vue&type=script&lang=ts"
export * from "./PaginatedCompanyDropdown.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__